import { logUtil,typeUtil,urlUtil,objUtil } from "@repo/lib-common";

export class ClientConfig{
    measurementId: typeUtil.StringOrUndefined;
    advertiserId:typeUtil.StringOrUndefined;
    clientDomain:typeUtil.StringOrUndefined;

    readonly isProd:boolean;
    public constructor(init?: Partial<ClientConfig>) {
        Object.assign(this, init);
        this.clientDomain=init?.clientDomain ?? urlUtil.getHostNameFromUrl();
        this.isProd =init?.isProd ?? import.meta.env.PROD  ;

    }



}

export function validateClientConfig(data:ClientConfig|Partial<ClientConfig>|undefined):boolean{
    if(objUtil.isObjNullOrUndefined(data)) {
        logUtil.consoleError("client config are undefined");
        return false;
    }
    if(objUtil.isNullOrEmpty(data!.advertiserId)) {
        logUtil.consoleError("client config advertiserId is undefined");
        return false;
    }
    if(objUtil.isNullOrEmpty(data!.measurementId)) {
        logUtil.consoleError("client config measurementId is undefined");
        return false;
    }
    return true;

}

